module.exports = __webpack_public_path__ + "empty_flow.png?0d5bed62680d607e9bb5eb9ef1ac8725";